export type DataMode = 'mock' | 'api';

const LS_MODE = 'helpydoc_data_mode';

export function getDataMode(): DataMode {
  const fromEnv = import.meta.env.VITE_DATA_MODE as DataMode | undefined;
  if (fromEnv === 'api' || fromEnv === 'mock') return fromEnv;
  try {
    const stored = localStorage.getItem(LS_MODE);
    if (stored === 'api' || stored === 'mock') return stored;
  } catch {
    /* ignore */
  }
  return 'mock';
}

export function setDataMode(mode: DataMode): void {
  localStorage.setItem(LS_MODE, mode);
}
